import SpinnerThreeBouncePlugin from './spinner_three_bounce'
export default SpinnerThreeBouncePlugin



// WEBPACK FOOTER //
// ./src/plugins/spinner_three_bounce/index.js